import { render, staticRenderFns } from "./BreederList.vue?vue&type=template&id=036b2534&"
import script from "./BreederList.vue?vue&type=script&lang=js&"
export * from "./BreederList.vue?vue&type=script&lang=js&"
import style0 from "./BreederList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports